export function Footer() {
  return (
    <footer className="border-t border-border bg-card py-6">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center text-sm text-muted-foreground">
          <p>
            &copy; {new Date().getFullYear()} Seguros Zurich. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
